<template>
	<v-dialog v-model="groupDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{ fromHeader ? t('groupCreate') : t('storeConditions')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" 
						@click="groupDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 mb-2">
              {{ fromHeader ? t('groupEditBodyTitle') : t('groupEditStoreConditions')}}
            </v-row>
            <v-row class="ma-0 pa-0 mb-2" justify="space-between" align="center">
              <v-col class="ma-0 pa-0 pr-2" cols="7">
                <!-- vuetify Autocompletes API search 사용할것 -->
								<v-autocomplete
									v-model="storeSearchInputValue"
									:items="searchResult"
									:loading="searchLoading"
									:search-input.sync="search" append-icon=""
									color="white" dark hide-no-data hide-selected outlined dense hide-details
									item-text="customerName"
									:placeholder="tg('storeNameInputPlaceholder')"
									return-object style="width:100%;"
								></v-autocomplete>
              </v-col>
              <v-col class="ma-0 pa-0" cols="5">
                <v-row class="ma-0 pa-0" justify="space-between">
                  <v-col class="ma-0 pa-0 pr-2" cols="6">
                    <v-btn id="blue_btn" width="100%" height="2rem"
                      @click="addToSelectedStore"
											>{{t('add')}}</v-btn>
                  </v-col>
                  <v-col class="ma-0 pa-0" cols="6">
                    <v-btn id="blue_btn" width="100%" height="2rem"
											@click="filterDialogVisible()">{{t('groupEditStoreSearch')}}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" justify="center">
              <v-col id="selected_store_list" class="ma-0 pa-0 mt-1 mb-1">
                <v-col id="store_item" class="ma-0 pa-0 pl-3 pr-5"
                  v-for="(item, index) in selectedStore" :key="index">
                  <v-row class="ma-0 pa-2 pt-1 pb-1" align="center" justify="space-between">
                    <v-col class="ma-0 pa-0 pl-1" cols="auto">{{item.customerName}}</v-col>
                    <v-col class="ma-0 pa-0" cols="auto">
                      <v-btn width="auto" height="auto" class="ma-0 pa-0" id="back_clean_btn" elevation="0" 
                        :ripple="false" @click="deleteStoreName(index)">
                        <v-img max-height="1.25rem" max-width="1.25rem"
                          src="@/assets/images/close.png"></v-img>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pt-5 pb-2" align="center" justify="center">
              <v-btn id="grey_btn" width="8rem" height="2rem" class="ma-0 pa-0 mr-2"
						 		@click="cancelEdit">{{t('back')}}</v-btn>
								<v-btn id="blue_btn" width="8rem" height="2rem" class="ma-0 pa-0"
                :loading="loading"
								@click="requestDetermine">{{t('determine')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>

		<FilterDialog :dialogVisible="storeFilterDialogVisible" :storeDataVisible="true" 
			:brandBoxVisible="brandFilterDialogVisible" :filterVisible="filterOpenVisible"
			@visible="storeFilterDialogVisibleFunc" @edit="editFunc" />
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
import FilterDialog from '@/components/dialogs/FilteringDialog.vue';
import { searchStoresByName } from '@/api/storeSearchCache';
export default {
	props: {
		dialogVisible: Boolean,
		fromHeader: Boolean, // 점포그룹 헤더에서 매장편집을 열때 true!
    fromNoti: Boolean, // 설정>알람설정 페이지에서 매장편집을 열때 true!
    group: Array | Object,
		cameraStatusStoreList: Array,
		notiStoreList: Array,
	},
	components: {
		customDialog, FilterDialog
	},
	mixins: [mixin.common],
	data: () => ({
		groupDialogVisible: false,
		storeFilterDialogVisible: false,
    brandFilterDialogVisible: false,
    filterOpenVisible: false,
    fromStoreGroup: false,
    currentGroupId: '',
		currentGroup: {
			stores: []
		},
    storeSearchInputValue: null,
    searchLoading: false,
    model: null,
    search: null,
		searchResult: [],
		selectedStore: [],
		setSelectedStores: [],
    loading: false,
		tempDeleteStores: [],
	}),
	watch: {
		dialogVisible: function(item) {
			this.groupDialogVisible = item;
			if(item) {
				if(this.currentGroupId != undefined) { //매장 그룹에서 다이얼로그를 여는 경우
					this.tempDeleteStores = [];
					this.currentGroup = this.group;
					this.currentGroupId = this.group.id;
					this.selectedStore = this.group.stores;
				}
				if(this.cameraStatusStoreList != undefined) {
					// 카메라상태 페이지에서 다이알로그를 여는 경우
					console.log(this.cameraStatusStoreList);
					this.selectedStore = JSON.parse(JSON.stringify(this.cameraStatusStoreList));
				}
				if(this.notiStoreList != undefined) {
					// 설정 > 알람설정 페이지에서 다이알로그를 여는 경우
					console.log(this.notiStoreList);
					let temp = JSON.parse(JSON.stringify(this.notiStoreList));
					temp.forEach((item, index) => {
						temp[index].customerName = item.name;
					})
					this.selectedStore = temp;
				}
			}
		},
		groupDialogVisible: function(item) {
			this.$emit('visible', item);
		},
    group: function(item) {
			// console.log(item);
			this.currentGroup = item;
			this.currentGroupId = item.id;
      this.selectedStore = item.stores;
		},
    search(val) {
			this.requestStoreSearch(val);
		},
    storeSearchInputValue: function(item) {
			// v-autocomplate에서 선택한 값
			console.log(item);
		},
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
		let savedStoreGroupList = this.$store.getters.getStoreGroupList;
    if(this.currentGroupId != undefined) { //매장 그룹에서 다이얼로그를 여는 경우
		  this.currentGroup = savedStoreGroupList.find(r => r.id === this.$route.query.groupId);
		  this.selectedStore = this.currentGroup.stores;
      this.fromStoreGroup = true;
    }
	},
	methods: {
    tg(t) {
      return this.$t("lang.group." + t);
    },
    deleteStoreName(index) {
			this.tempDeleteStores.push(this.selectedStore[index]);
      this.selectedStore.splice(index, 1);
    },
    filterDialogVisible() {
      this.storeFilterDialogVisible = true;
      this.brandFilterDialogVisible = this.fromStoreGroup;
    },
		storeFilterDialogVisibleFunc(visible) {
			this.storeFilterDialogVisible = visible;
		},
    editFunc(stores) {
			let newArray = [ ...this.selectedStore, ...stores ];
			const arraySet = newArray.filter((store, idx, arr) => {
				return arr.findIndex((item) => item.unisCustomerCd === store.unisCustomerCd) === idx
			});
			// console.log(arraySet);
      this.selectedStore = arraySet;
    },
		cancelEdit() {
			if(this.tempDeleteStores.length != 0) {
				this.tempDeleteStores.forEach(store => {
					this.selectedStore.push(store);
				})
			}
			this.groupDialogVisible = false;
		},
    async requestStoreSearch(value) {
			this.searchLoading = true;
			try {
				this.searchResult = await searchStoresByName(value);
				console.log('%cStore Search (cached)\n', "color:#008DD0;", this.searchResult.length);
			} catch (e) {
				console.error('requestStoreSearch failed', e);
				this.searchResult = [];
			} finally {
				this.searchLoading = false;
			}
		},
  	requestDetermine() {
			if(this.selectedStore.length == 0) {
				this.showToastMessage('店舗を0店舗に修正することはできません。');
				return;
			}
      if(this.fromNoti == false && this.cameraStatusStoreList == undefined) {
        this.requestUpdateStoreGroup();
      } else if(this.fromNoti == true && this.cameraStatusStoreList == undefined) {
        this.searchNotificationGroup();
      } else if(this.fromNoti == false && this.cameraStatusStoreList != undefined) {
				// 카메라 상태 페이지
				this.searchNotificationGroup();
			}
    },
    async requestUpdateStoreGroup() {
			this.loading = true;
			let params = {
				groupName: this.currentGroup.groupName,
				stores: this.selectedStore,
				id: this.$store.getters.getUmid
			};
			await this.networkController.updateStoreGroup(params, this.currentGroupId)
			.then(async (res) => {
				let oldStoreGroupList = this.$store.getters.getStoreGroupList;
				let currentGroupIndex = oldStoreGroupList.findIndex(r => r.id === this.currentGroupId);
				oldStoreGroupList[currentGroupIndex].stores = this.selectedStore;
				let newStoreGroup = {
					stores: this.selectedStore,
					...oldStoreGroupList[currentGroupIndex]
				};
				oldStoreGroupList[currentGroupIndex] = newStoreGroup;
				await this.$store.commit('setStoreGroupList', oldStoreGroupList);
				this.$emit('update', newStoreGroup);
        this.loading = false;
        this.groupDialogVisible = false;
				this.showToastMessage(this.tmb('requestSuccess'));
			}).catch(error => {
				this.loading = false;
			});
		},
    searchNotificationGroup() { 
			// 설정 - > 알림설정에서 매장을 선택하는 경우
			// 또는 카메라상태 페이지에서 선택하는 경우
      this.loading = true;
      //점포 리스트 emit
      this.$emit('selectedStores', this.selectedStore);
      this.loading = false;
      this.groupDialogVisible = false;
      this.selectedStore = []; //검색 초기화
    },
    addToSelectedStore() {
			this.checkStoreExistence().then((store) => {
				if(store != undefined) {
					let duplicateCheck = this.selectedStore.some((element) => {
						return element.customerName === store.customerName
					});
					if(duplicateCheck == false) { // duplicateCheck가 true일때는 customerName 중복
						this.selectedStore.push({
							areaCd: store.areaCd,
							customerName: store.customerName,
							unisCustomerCd: store.unisCustomerCd
						});
					} else {
						this.showToastMessage(this.tmb('storeAlreadyAdded'));
					}
				}
			}).catch((error) => {
				console.log(error);
			});
    },
		checkStoreExistence() {
			return new Promise((resolve, reject) => {
				let result = undefined;
				if(this.storeSearchInputValue == null) reject(undefined);
				this.searchResult.forEach((item, index, array) => {
					if(item.customerName === this.storeSearchInputValue.customerName) {
						result = item;
					}
					if (index === array.length - 1) {
						resolve(result);
					}
				});
			});
		},
	}
}
</script>

<style lang="scss" scoped>
.store_name_select {
  width: 97.5%;
	height: 2rem;
  background-color: #272727;
  border: 1px solid #4A4A4A;
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  .v-list-item--active .v-list-item__content {
    color: white;
  }
  .v-list-item__icon.v-list-group__header__prepend-icon {
    color: white;
  }
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 2rem;
	}
	.v-text-field input {
		padding: 0;
	}
	.v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
		padding: 0;
	}
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}

  .v-autocomplete {
		background-color: #272727;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#selected_store_list {
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  width: 100%;
  min-height: 350px;
	max-height: 350px;
	overflow: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#store_item {
  border-bottom: 1px solid #4A4A4A;
}
</style>